module.exports = __webpack_public_path__ + "static/media/md-1.8c6d5392.jpg";